import React from 'react';

import { translate } from 'services/i18nService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import ProfileStore from 'stores/ProfileStore';

import cam4Logo from '../../../images/logo/c4logo_white.png';

import styles from './EmbedCamOffline.css';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const EmbedCamOffline = () => {
  const { profileName } = ProfileStore;

  const handleRedirect = () => {
    window.open(`/${profileName}`);
  };

  return (
    <div className={styles.embedCamOfflineWrapper} onClick={handleRedirect}>
      <img alt="avatar" className={styles.perfPicture} src={`${BASE_URL}/avatar/user/60x60/${profileName}.jpg`} />
      <p>{translate('v2profile.embed.link')}</p>
      <img alt="logo" className={styles.logoPicture} src={cam4Logo} />
    </div>
  );
};

export default EmbedCamOffline;
